import Vue from 'vue'
import { store } from '@/store'

const baseURL = 'https://dev.lfs.rest/web/v3/'

export default class Localization {
  public static async getProjects() {
    try {
      const req = await Vue.axios.get('/i18n/projects', {
        baseURL
      })

      if (req.statusText != 'OK') {
        throw new Error('getProjects error!')
      }

      return req.data
    } catch (error) {
      console.log(error)
    }
  }

  public static async addProject(title: string, description: string) {
    try {
      const req = await Vue.axios.post('/i18n/project', {
        title,
        description
      }, {
        baseURL
      })

      if (req.statusText != 'OK') throw new Error('addProject error!')

      return true
    } catch (error) {
      console.log(error)
    }
  }

  public static async deleteProject(projectId: string) {
    try {
      const req = await Vue.axios.delete(`/i18n/project/${ projectId }`, {
        baseURL
      })

      if (req.statusText != 'OK') throw new Error('deleteProject error!')

      return true
    } catch (error) {
      console.log(error)
    }
  }

  public static async editProject(data: any) {
    try {
      const req = await Vue.axios.put(`/i18n/project/${data._id}`, {
        title: data.title,
        description: data.description
      },{
        baseURL
      })

      if (req.statusText != 'OK') throw new Error('editProject error!')

      return true
    } catch (error) {
      console.log(error)
    }
  }

  public static async addKey(projectId: string, data: any) {
    try {
      const req = await Vue.axios.post(`/i18n/project/${projectId}/key`, {
        section: data.section,
        platforms: ['ios'],
        description: data.description,
        title: data.key,
        translate: {
          ru: data.ru,
          en: data.en,
          de: data.de
        }
      }, {
        baseURL
      })

      if (req.statusText != 'OK') throw new Error('addKey Error!')

      return true
    } catch (error) {
      console.log(error)
    }
  }

  public static async getKeys(projectId: string) {
    try {
      const req = await Vue.axios.get(`/i18n/project/${projectId}/keys`, {
        baseURL
      })

      if (req.statusText != 'OK') throw new Error('getKeys Error!')

      const res = await req.data.keys

      return res
    } catch (error) {
      console.log(error)
    }
  }

  public static async removeKey(projectId: string, keyId: string) {
    try {
      const req = await Vue.axios.delete(`/i18n/project/${projectId}/key/${keyId}`, {
        baseURL
      })

      if (req.statusText != 'OK') throw new Error('updateKey Error!')

      return true
    } catch (error) {
      console.log(error)
    }
  }

  public static async editKey(projectId: string, data: any) {
    try {
      const req = await Vue.axios.put(`/i18n/project/${projectId}/key/${data.keyId}`, {
        section: data.Раздел,
        platforms: ['ios'],
        description: data.Описание,
        title: data.Ключ,
        translate: {
          ru: data.ru,
          en: data.en,
          de: data.de
        }
      }, {
        baseURL
      })

      if (req.statusText != 'OK') throw new Error('updateKey Error!')

      return true
    } catch (error) {
      console.log(error)
    }
  }

  public static async getIosFile(projectId: string) {
    const req = await Vue.axios.get(`/i18n/project/${projectId}/pack/ios`, {
      baseURL,
      responseType: <any>'blob'
    })
    const url = window.URL.createObjectURL(new Blob([req.data]))
    const link = document.createElement('a')

    link.href = url
    link.setAttribute('download', 'Localization Ios.zip') //or any other extension
    link.click()
  }

  public static async getWebFile(projectId: string) {
    const req = await Vue.axios.get(`/i18n/project/${projectId}/pack/web`, {
      baseURL
    })
    const url = window.URL.createObjectURL(new Blob([req.data]))
    const link = document.createElement('a')

    link.href = url
    link.setAttribute('download', 'Localization Web.ts')
    link.click()
  }

  public static async getAndroidFile(projectId: string) {
    const req = await Vue.axios.get(`/i18n/project/${projectId}/pack/android`, {
      baseURL,
      responseType: <any>'blob'
    })
    const url = window.URL.createObjectURL(new Blob([req.data]))
    const link = document.createElement('a')

    link.href = url
    link.setAttribute('download', 'Localization Android.zip') //or any other extension
    link.click()
  }
}
